import { styled, Typography } from "@mui/material";

const StyledTypography = styled(Typography)(({ theme, fontWeight: weight }) => {
  const fontWeight = {
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
  };

  return {
    fontWeight: fontWeight[weight],
  };
});

export { StyledTypography };
